export default __webpack_public_path__ + "static/media/Group 3535.75270137.jpg";